/**
 * Utility to setup authentication for testing
 * Run this in the browser console to get a valid admin token
 */

export const setupAdminAuth = async () => {
  try {
    // Try to login with default admin credentials
    const response = await fetch('/api/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: 'admin@siete.online',
        password: 'admin123'
      })
    });

    if (!response.ok) {
      throw new Error('Login failed');
    }

    const data = await response.json();
    
    if (data.success && data.data?.accessToken) {
      // Store the token in localStorage
      localStorage.setItem('auth_token', data.data.accessToken);
      
      // Store user data
      localStorage.setItem('user', JSON.stringify(data.data.user));
      
      console.log('✅ Admin authentication successful!');
      console.log('Token stored in localStorage as "auth_token"');
      console.log('User:', data.data.user);
      
      // Reload the page to apply the new auth state
      window.location.reload();
      
      return data.data;
    } else {
      throw new Error('Invalid response format');
    }
  } catch (error) {
    console.error('❌ Authentication failed:', error);
    console.log('Try running: setupAdminAuth() with correct credentials');
    return null;
  }
};

// Export for use in browser console
(window as any).setupAdminAuth = setupAdminAuth;

// Also create a function to manually set a token (for testing)
export const setAuthToken = (token: string) => {
  localStorage.setItem('auth_token', token);
  console.log('✅ Token set in localStorage');
};

(window as any).setAuthToken = setAuthToken;